import {
	Card,
	CardBody,
	Container,
	Row,
	Col,
	Button,
	Breadcrumb,
	BreadcrumbItem,
	CardHeader,
} from "reactstrap"
// core components
import { Component } from "react"
import { Link } from "react-router-dom"

import { connect } from "react-redux"
import { sacrament } from "../../../redux/actions"

import moment from "moment"

class ChildSubmissionDetail extends Component {
	getChildSubmissionDetail() {
		this.props.getChildSubmissionDetail(this.props.match.params.childId)
	}
	componentDidMount() {
		this.getChildSubmissionDetail()
	}

	render() {
		return (
			<>
				{/* Page content */}
				<Container fluid className='mb-5'>
					<div>
						<Breadcrumb>
							<BreadcrumbItem>
								<Link to='/admin/sacrament'>Sakramen</Link>
							</BreadcrumbItem>

							<BreadcrumbItem>
								<Link to='/admin/sacrament/child-submission'>
									Penyerahan Anak
								</Link>
							</BreadcrumbItem>

							<BreadcrumbItem active>Informasi Detail</BreadcrumbItem>
						</Breadcrumb>
					</div>
					{/* Table */}
					<Row>
						<Col xl={7}>
							<Card>
								<CardHeader>
									<h1>Informasi Detail</h1>
								</CardHeader>
								<CardBody>
									<Container>
										<table>
											<tr>
												<td
													style={{
														minWidth: "200px",
													}}
												>
													Nama
												</td>
												<td>{this.props.child.detail.name}</td>
											</tr>

											<tr>
												<td>Tempat Lahir</td>
												<td>{this.props.child.detail.birthplace}</td>
											</tr>

											<tr>
												<td>Tanggal Lahir</td>
												<td>
													{moment(
														this.props.child.detail.birthdate,
														"YYYY-MM-DD"
													)
														.locale("id")
														.format("DD MMM YYYY")}
												</td>
											</tr>

											<tr>
												<td>Nama Ayah</td>
												<td>{this.props.child.detail.father_name}</td>
											</tr>

											<tr>
												<td>Nama Ibu</td>
												<td>{this.props.child.detail.mother_name}</td>
											</tr>

											<tr>
												<td>Alamat Lengkap</td>
												<td>{this.props.child.detail.address}</td>
											</tr>

											<tr>
												<td>No. Whatsapp</td>
												<td>{this.props.child.detail.phone}</td>
											</tr>
										</table>

										<div className='d-flex justify-content-end'>
											<Button
												color='primary'
												onClick={() => {
													this.props.history.push(
														"/admin/sacrament/child-submission"
													)
												}}
											>
												Kembali
											</Button>
										</div>
									</Container>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return { child: state.childSubmission }
}

const mapDispatchToProps = {
	getChildSubmissionDetail: sacrament.getChildSubmissionDetail,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChildSubmissionDetail)
